exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".signatures-two-column[data-v-e439ad96]{width:100%}.signature-wrapper[data-v-e439ad96]{position:relative;float:left;width:50%;padding:30px}.signature-wrapper.signature-left[data-v-e439ad96]{padding-left:0}.signature-wrapper.signature-right[data-v-e439ad96]{padding-right:0}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e439ad96","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/document-parts/signatures.vue
// module id = 432
// module chunks = 0